import type { AxiosRequestConfig } from 'axios';

import type { SwaggerResponse } from '@/services/config';
import { Http } from '@/services/httpRequest';

import type { NavigationResolveResponse } from './types';

/**
 * Internal fetchers for GET /api/v2/navigation/:id and /navigation/search.
 * Do not commit a swagger dump until `updateApi` has generated hooks for these
 * routes; then delete this file and wrap the generated hooks instead.
 */
export function searchNavigationByName(
    query: string,
    configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<NavigationResolveResponse>> {
    return Http.getRequest(
        '/api/v2/navigation/search',
        { q: query },
        undefined,
        undefined,
        configOverride
    );
}

export function getNavigationById(
    id: number,
    configOverride?: AxiosRequestConfig
): Promise<SwaggerResponse<NavigationResolveResponse>> {
    return Http.getRequest(
        `/api/v2/navigation/${id}`,
        undefined,
        undefined,
        undefined,
        configOverride
    );
}
